import { PagedSearch } from '../../shared/model/paged-search.model';
//import moment from 'moment-es6';
import { MomentService } from '../../shared/moment/moment.service';

export class EventSearchParams extends PagedSearch {
  private _momentService: MomentService;

  public Keyword: string;
  public OrganizationEvent: boolean;
  public CommunityEvent: boolean;
  public MembersOnlyEvent: boolean;
  public InternalEvent: boolean;
  public EventsWithPendingRegistrationsOnly: boolean = false;
  public SearchDateBegin: Date;
  public SearchDateEnd: Date;
  public EventId: number;
  public EventType: string = null;

  public constructor() {
    super();

    this._momentService = new MomentService();

    this.Keyword = '';
    this.PageSize = 10;
    this.OrganizationEvent = true;
    this.CommunityEvent = false;
    this.MembersOnlyEvent = true;
    this.InternalEvent = true;
    this.SearchDateBegin = null; //moment(new Date()).format("YYYY-MM-DD");
    this.SearchDateEnd = null; //moment(new Date()).add(12, "months").format("YYYY-MM-DD");
    this.OrderBy = 'StartDate';
    this.EventId = null;
  }
}
